import { GlyphType } from '../../../../../shared/components/Icon';

export type IntegrationItemType = {
  id: string;
  glyph: GlyphType;
  href: string;
  name: string;
  width?: string;
  height?: string;
};

export const listOfIntegrations: IntegrationItemType[] = [
  {
    id: 'freshdeskCustomerSuccess',
    name: 'Freshdesk Customer Success',
    href: 'freshdeskcustomersuccess',
    glyph: 'freshdeskcustomersuccess',
    width: '29',
    height: '29',
  },
  {
    id: 'freshdeskSupportDesk',
    name: 'Freshdesk Support Desk',
    href: 'freshdesksupportdesk',
    glyph: 'freshdesksupportdesk',
    width: '29',
    height: '29',
  },
  {
    id: 'freshdeskMessaging',
    name: 'Freshdesk Messaging',
    href: 'freshdeskmessaging',
    glyph: 'freshdeskmessaging',
    width: '29',
    height: '29',
  },
  {
    id: 'freshservice',
    name: 'Freshservice',
    href: 'freshservice',
    glyph: 'freshservice',
    width: '29',
    height: '29',
  },
  {
    id: 'freshsalesSuite',
    name: 'Freshsales Suite',
    href: 'freshsalessuite',
    glyph: 'freshsalessuite',
    width: '29',
    height: '29',
  },
  {
    id: 'slack',
    name: 'Slack',
    href: 'slack',
    glyph: 'slack',
    width: '25',
    height: '25',
  },
  {
    id: 'microsoftTeams',
    name: 'Microsoft Teams',
    href: 'teams',
    glyph: 'teams',
    width: '26',
    height: '25',
  },
];
